@if (state) {
  <span role="img" aria-label="Ja" nz-tooltip nzTooltipTitle="Ja">
    <i
      class="boolean-icon boolean-icon--yes"
      nz-icon
      nzType="check-circle"
      nzTheme="fill"
      aria-hidden="true"
    ></i>
  </span>
} @else {
  <span role="img" aria-label="Nein" nz-tooltip nzTooltipTitle="Nein">
    <i
      class="boolean-icon boolean-icon--no"
      nz-icon
      nzType="close-circle"
      nzTheme="fill"
      aria-hidden="true"
    ></i>
  </span>
}
